<template>
  <b-collapse
    :open.sync="isOpen"
    @open="handleOpen"
    @close="handleClose"
  >
    <div
      :class="['dropdown-label', { 'has-background-primary has-text-white': primary }]"
      slot="trigger"
    >
      <slot name="label"></slot>

      <div v-if="editable" class="is-pulled-right" @click="handleEdit($event)">
        <icon-default
          size="is-small"
          class="edit-icon"
          icon="edit"
          :color="{ 'is-primary' : isEditingVar }"
        ></icon-default>
      </div>

      <icon-default
        size="is-small"
        :icon="isOpen ? 'collapse' : 'expand'"
        class="arrow-icon"
      ></icon-default>
    </div>

    <slot></slot>
  </b-collapse>
</template>

<script>
export default {
  name: 'StatusCollapseSection',
  props: {
    value: Boolean,
    primary: Boolean,
    editable: Boolean,
    isEditingVar: Boolean,
    editCallback: Function,
    closeCallback: Function,
    openCallback: Function
  },
  data() {
    return {
      isOpen: this.value,
      isEditing: false
    }
  },
  watch: {
    value(val) {
      this.isOpen = val;
    }
  },
  methods: {
    handleOpen() {
      if (this.openCallback) this.openCallback();
      this.$emit('input', true);
    },
    handleClose() {
      if (this.closeCallback) this.closeCallback();
      this.$emit('input', false);
    },
    handleEdit(ev) {
      ev.stopPropagation();
      if (this.editCallback) this.editCallback();
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../styles/variables/variables";

 .dropdown-label {
  position: relative;
  border: 1px solid #ccc;
  font-weight: bold;
  padding: 10px;
  margin: 10px 0;
  background-color: #fff;
}

.arrow-icon {
  position: absolute;
  padding-left: 10px;
  font-weight: bold !important;
  font-size: 20px;
}

.edit-icon {
  font-size: 20px;
  transition: 0.2s;
  &:hover {
    color: $primary;
  }
}
</style>
